import React, { useEffect, useRef, useState } from "react";
import {
  NavLink,
  Outlet,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { http } from "../../helpers/http";
import { Rating } from "react-simple-star-rating";
import { placeholderHandler } from "../../helpers/help";
import AddCartItem from "../modals/AddCartItem";
import Restauranttime from "../modals/Restauranttime";
import { updateFullScreenLoader } from "../../redux/actions/authActions";
import { useDispatch, useSelector } from "react-redux";
import RangeSlider from "react-range-slider-input";
import { updateRestaurantInfo } from "../../redux/actions/restaurantActions";
import { PRICE_SYMBOL } from "../../eums/messages";
import useCurrentPosition from "../../helpers/customHooks/useCurrentPosition";
import copy from 'copy-to-clipboard';
import { ButtonToolbar, OverlayTrigger, Tooltip } from "react-bootstrap";

const RestaurantDetails = (props) => {

  // const tooltip = (
  //   <Tooltip id="tooltip">
  //     <strong>Copy to clipboard</strong>
  //   </Tooltip>
  // );


  const { hide } = props;
  let { outletId } = useParams();
  outletId = +outletId;
  const [toggleMenu1, setToggleMenu1] = useState(true);
  const dispatch = useDispatch();
  const restaurantInfo = useSelector((state) => state?.restaurant.info);
  const { pathname } = useLocation();
  const [active1, setActive1] = useState(false);
  const { latitudeData, longitudeData } = useCurrentPosition();
  const [copied, setCopied] = useState(false);

  const [maxPrice, setMaxprice] = useState([0, 0]);
  const navigate = useNavigate();
  const rangeRef = useRef(null);
  const location = useLocation();
  const locPath = location.pathname



  // function copyText(event) {
  //   copy(event);
  // }


  function copyText(event) {
    copy(event);
    setCopied(true);

    // Reset the copied state after a certain duration (e.g., 3 seconds)
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  }


  // const tooltip = (
  //   <Tooltip id="tooltip">
  //     <strong>{copied ? 'Copied' : 'Copy to clipboard'}</strong>
  //   </Tooltip>
  // );


  const tooltip = (
    <Tooltip id="tooltip" className={copied ? 'green-tooltip' : ''}>
      <strong>{copied ? 'Copied' : 'Copy to clipboard'}</strong>
    </Tooltip>
  );

  const [openRestTimeModal, setOpenRestTime] = useState({
    state: false,
    data: "",
  });

  const handleShow = (data) => setOpenRestTime({ state: true, data: data });

  const restaurantDetails1 = (type) => {
    dispatch(updateFullScreenLoader(true));
    http(
      {
        method: "POST",
        url: `listDishes`,
        isSecure: true,
        body: {
          latitude: latitudeData,
          longitude: longitudeData,
          // maxprice: maxPrice[1],
          outletId,
        },
      },
      (res) => {

        if (type == "apply" && maxPrice[1] > 0) {
          setActive1(true);
          setToggleMenu1(false);
        } else {
          // toggleMenuD()
          setToggleMenu1(false);
          setActive1(false);
        }
        // setMaxprice([0,0])


        if (res.dishes.length > 0) {
          res.dishes.forEach(element => {
            if (element.categoryValues.length > 0) {
              element.categoryValues.forEach(res => {
                if (res.isCustomizable === 0) {
                  res.dishCustomisation = [];
                }
              })
            }
          });
        }
        dispatch(updateRestaurantInfo(res));
        dispatch(updateFullScreenLoader(false));
        sessionStorage.setItem("restaurantInfo", JSON.stringify(res));
      }
    );
  };

  useEffect(() => {
    latitudeData && longitudeData && restaurantDetails1();
  }, [latitudeData, longitudeData]);

  const backPage = () => {
    navigate("/restaurants");
  };

  const toggleMenuD = () => {
    setToggleMenu1(!toggleMenu1);
    // setActive1((ps) => !ps);
  };

  const clearFilter = () => {
    setMaxprice(0);
    window.location.reload(true);
    setToggleMenu1(false);
    setActive1(false);
  };

  useEffect(() => {
    const width = window.innerWidth;

    if (width < 768) {
      const navEl = document.getElementsByClassName("range-slider__range");
      for (var i = 0; i < navEl.length; i++) {
        navEl[i].style.width = "2.333%";
      }
    }
  }, [window.innerWidth]);
  // const clearData = () => {
  //   setMaxprice(0);
  // }


  return (
    <>

      <div className="restaurantsNear_menu">
        <div className="cus_container">
          <div className="d-md-flex mobileview_TFDC">
            {/* <button
              className={`toggle filtrbtnMobile ${active1 === true ? "filter-mobile-active" : ""
                } `}
              onClick={() => toggleMenuD()}
            >
              <img src="./assets/img/filtterToggle.svg" alt="filterToggle1" />
            </button> */}
            {/* <div
              className={
                toggleMenu1 ? "item_filter_box" : "item_filter_box activeMenu"
              }
            > */}
            {/* <h4 className="head4 bor_lineR">All Details</h4> */}
            {/* <ul>
                <li>
                  <NavLink to="menu" className="filterbtn flex-row">
                    <img
                      src="./assets/img/menu_filter.svg"
                      alt="filter"
                      className="filter me-2 d-flex align-items-center imgw_s"
                    />
                    Menu
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="reviews"
                    className="filterbtn flex-row"
                    // state={state}
                    onClick={() => toggleMenuD()}
                  >
                    <img
                      src="./assets/img/star_Accor.svg"
                      alt="filter"
                      className="filter me-2 d-flex align-items-center"
                    // state={toggleMenu1}
                    />
                    Reviews
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="info"
                    className="filterbtn flex-row"
                    onClick={() => toggleMenuD()}
                  >
                    <img
                      src="./assets/img/info_icon.svg"
                      alt="filter"
                      className="filter me-2 d-flex align-items-center"
                    />
                    Restaurants Info
                  </NavLink>
                </li>
              </ul> */}
            {/* <div className="line-content-middle my-3"></div> */}
            {/* <div className=" px-3 ">
                <div className="filter-title ">By Price</div>
                <div className="rang-box py-2 position-relative">


                  <RangeSlider
                    className="single-thumb my-3"
                    value={maxPrice ? maxPrice : 0}
                    onInput={setMaxprice}
                    min={0}
                    max={100}
                    thumbsDisabled={[true, false]}
                    rangeSlideDisabled={true}
                    defaultValue={[0, maxPrice ? maxPrice : 0]}
                    ref={rangeRef}
                  />
                </div>
                <div className="filter-title Price-ft">
                  Price:{" "}
                  <span>
                    {PRICE_SYMBOL}
                    {maxPrice[1]}
                  </span>{" "}
                  - <span>{PRICE_SYMBOL}100</span>
                </div>
              </div> */}

            {/* <div className="d-lg-flex align-items-center mt-5 px-3">
                <button
                  className="cusbtn me-3 w-100"
                  onClick={() => restaurantDetails("apply")}
                >
                  Apply
                </button>
                <button
                  className="hoverbtn w-100 mt-3 mt-lg-0"
                  onClick={clearFilter}
                >
                  Clear All
                </button>
              </div> */}
            {/* <img
                src="./assets/img/filter_f-img.png"
                alt="food img"
                className="footerimg-filter"
              /> */}
            {/* </div> */}
            <div className="restaurant_view_all res_menu_screen">
              {!hide && (
                <a className="arrow_back d-inline" onClick={() => backPage()}>
                  <img src="./assets/img/arrowBack.svg" alt="arrow back" />
                  Back
                </a>
              )}
              <div className="d-flex justify-content-between align-items-center mt-4 mb-4">
                <div className="col_left">
                  <h4 className="head4 mb-0">Restaurant </h4>
                </div>
                <div className="col-right">
                  {/* <form>
                    <div className="inputGroup text-center">
                      <input
                        type="text"
                        className="input_control input-inside-img bg-white "
                        placeholder="Search here..."
                      />
                    </div>
                  </form> */}
                </div>
              </div>

              <div className="view_data_resaurant">
                <div className="grid_item_single">
                  <div className="restaurants_container">
                    <div className="restaurants_group">
                      <div className="restaurants_item d-block bg-transparent shadow-none p-0">
                        <div className="resto_img_section">
                          <img
                            onError={placeholderHandler}
                            src={restaurantInfo?.image}
                            alt="restaurant"
                            className="resto_img_section-img exHgt bg-white"
                          />
                        </div>
                        <div className="res_content py-2">
                          <div className="my-2 d-lg-flex align-items-start justify-content-between">

                            <div className="d-flex align-items-start me-lg-5 flex-wrap">
                              <h3 className="head3 mb-0 text-break me-4">
                                {restaurantInfo?.outlet_name}

                              </h3>
                              <div className="d-flex ms-auto">
                                <div className="ratting_sec ratting_secBg ms-auto  me-1 mt-xl-2 mt-1">
                                  {/* <div className="review_start">
                                  <Rating
                                    initialValue={restaurantInfo.averageRating}
                                    readonly
                                  />
                                </div> */}
                                  <div className="ratting_sec d-flex align-items-center ">
                                    <img src="./assets/img/star.svg" />
                                    <div className="review_start ms-2">
                                      <span><b>{restaurantInfo.averageReview}</b></span>
                                    </div>


                                    {/* <div className="review_start">
<Rating
  initialValue={item.averageReview}
  readonly
/>
</div> */}
                                  </div>
                                </div>
                                {/* {restaurantInfo.emergency_close === 1 ? restaurantInfo?.is_restro_online === 1 || restaurantInfo?.pickup_availability === 0 ? (
                                  <div className="btn_res close position-static px-3 mt-xl-2 mt-1">Close</div>
                                ) : (
                                  
                                )} */}

                                {(restaurantInfo?.emergency_close === 0 ?
                                  ((restaurantInfo?.is_restro_online === 1 ?
                                    restaurantInfo.pickup_availability === 0 ?
                                      <div className="btn_res close position-static px-3 mt-xl-2 mt-1">Close</div> :
                                      <div className="btn_res position-static open px-3 mt-xl-2 mt-1"> Open</div>
                                    : <div className="btn_res position-static close px-3 mt-xl-2 mt-1"> Close</div>)) :
                                  <div className="btn_res close position-static px-3 mt-xl-2 mt-1">Close</div>

                                )}

                                {/* {(restaurantInfo?.pickup_availability === 0 ?
                                  ((restaurantInfo?.is_restro_online === 0 ?
                                    restaurantInfo.emergency_close === 0 ?
                                      <div className="btn_res open position-static px-3 mt-xl-2 mt-1">Open</div> :
                                      <div className="btn_res position-static close px-3 mt-xl-2 mt-1"> Close</div>
                                    : "")) : <div className="btn_res open position-static px-3 mt-xl-2 mt-1">Open</div>

                                )} */}
                              </div>
                            </div>

                            <div className="dayShow-open my-3 my-lg-0">
                              {restaurantInfo?.restaurant_business_day?.length >
                                0 >
                                0
                                ? restaurantInfo?.restaurant_business_day?.map(
                                  (item, index) => (
                                    <div key={item.day} className="cirBox">
                                      {" "}
                                      {item?.day.toUpperCase().substring(0, 3)}
                                    </div>
                                  )
                                )
                                : "No data found"}
                              <button
                                className="cirBox text-black"
                                onClick={() =>
                                  handleShow(
                                    restaurantInfo?.restaurant_business_day,
                                    true
                                  )
                                }
                              >
                                See Hours
                              </button>
                            </div>
                          </div>
                          {/* <div className="d-flex align-items-center">
                            <input type="text"
                              //  value={`${process.env.REACT_APP_BASE_URL}BoomerangUserDev/#/restro-menu/${outletId}`}//old link
                             // value={`https://boomerangeatsapp.com/UserPickupQa/#/restro-menu/${outletId}`}//qa link
                              value={`https://boomerangeatsapp.com/BoomerangUserDev/#/restro-menu/${outletId}`}//dev link
                              className="copyinput input_control"
                              readOnly />
                            <ButtonToolbar>
                              <OverlayTrigger placement="top" overlay={tooltip}>
                                <button className="copy-button " onClick={() =>
                                  copyText(
                                    // `${process.env.REACT_APP_BASE_URL}BoomerangUserDev/#/restro-menu/${outletId}`//old link
                                    //`https://boomerangeatsapp.com/UserPickupQa/#/restro-menu/${outletId}`//qa link
                                      `https://boomerangeatsapp.com/BoomerangUserDev/#/restro-menu/${outletId}`//dev link
                                  )
                                }>
                                  <img src="./assets/img/copy-icon.png" />
                                </button>
                              </OverlayTrigger>
                            </ButtonToolbar>


                          </div> */}
                          <p className="txt nowrap mt-2 mb-0">
                            {restaurantInfo &&
                              restaurantInfo.foodTag?.map((tag, index) => {
                                return (
                                  <span className="me-2 " key={"tag" + index}>
                                    {tag.itemName +
                                      `${tag &&
                                        restaurantInfo?.foodTag?.length - 1 !==
                                        index
                                        ? ","
                                        : ""
                                      }`}
                                  </span>
                                );
                              })}
                          </p>

                          {/* {
                            restoDetails?.restaurant_business_day?.length > 0 > 0 ?
                              restoDetails?.restaurant_business_day?.map((item, index) => (
                                <div className="dayShow-open" key={index}>

                                  <div className="cirBox">{item?.day}</div>

                                </div>
                              )) : 'No data found'
                          } */}
                          {/* <div className="dayShow-open">
                            {restaurantInfo?.restaurant_business_day?.length >
                              0 >
                              0
                              ? restaurantInfo?.restaurant_business_day?.map(
                                (item, index) => (
                                  <div key={item.day} className="cirBox">
                                    {" "}
                                    {item?.day.toUpperCase().substring(0, 2)}
                                  </div>
                                )
                              )
                              : "No data found"}
                            <button
                              className="cirBox"
                              onClick={() =>
                                handleShow(
                                  restaurantInfo?.restaurant_business_day,
                                  true
                                )
                              }
                            >
                              <img
                                src="./assets/img/time.png"
                                alt="time"
                                className="w-100"
                              />
                            </button>
                          </div> */}
                          {/* <p className="txt mb-2 d-flex align-items-center blackC">
                            <img
                              src="./assets/img/canlendar.svg"
                              alt="start"
                              className="me-2"
                            />
                            {moment().format("dddd")} - Sunday
                          </p> */}
                          {/* <p className="txt mb-2 d-flex align-items-center blackC">
                            <img
                              src="./assets/img/time_remind.svg"
                              alt="start"
                              className="me-2"
                            /> */}
                          {/* {moment(
                              restoDetails?.restaurant_business_day?.from_time,
                              "HH:mm"
                            ).format("hh:mm")}
                            -
                            {moment(
                              restoDetails?.restaurant_business_day?.to_time,
                              "HH:mm"
                            ).format("hh:mm")} */}
                          {/* </p> */}
                        </div>
                        {!pathname.includes("menu") && (
                          //Here is Reviews or Info Component
                          <Outlet context={{ outletId }} />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {pathname.includes("menu") && (
                  //Here is Menu Component
                  <Outlet context={{ outletId }} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Restauranttime
        openRestTimeModal={openRestTimeModal}
        setOpenRestTime={setOpenRestTime}
      />
      <AddCartItem outletId={outletId} />
    </>
  );
};
export default RestaurantDetails;
